import { api } from "./api/apiSlice";

export const paymentApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllPayments: builder.query<any, void>({
      query: () => "payment/",
      providesTags: ["payment"],
    }),
    getPaymentsPaginated: builder.query<
      any,
      {
        page?: number;
        size?: number;
        search?: string;
        status?: string;
        payment_category?: string;
        from_date?: string;
        to_date?: string;
      }
    >({
      query: ({
        page = 1,
        size = 10,
        search,
        status,
        payment_category,
        from_date,
        to_date,
      } = {}) => {
        const params = new URLSearchParams({
          page: page.toString(),
          size: size.toString(),
        });

        if (search) params.append("search", search);
        if (status) params.append("status", status);
        if (payment_category)
          params.append("payment_category", payment_category);
        if (from_date) params.append("from_date", from_date);
        if (to_date) params.append("to_date", to_date);

        const finalUrl = `payment/paginated?${params.toString()}`;
        console.log("Final API URL:", finalUrl);

        return finalUrl;
      },
      providesTags: ["payment"],
    }),
    getPaymentById: builder.query<any, string>({
      query: (id) => `payment/${id}`,
    }),
    getPaymentsByTransactionId: builder.query<any, string>({
      query: (id) => `payment/transaction/${id}`,
    }),
    createAdditionalPayment: builder.mutation<any, any>({
      query: (data) => ({
        url: `payment/additional-cost-payment`,
        method: "POST",
        body: data,
      }),
    }),
    processofflinePayment: builder.mutation<any, any>({
      query: ({ data, id }) => ({
        url: `payment/${id}/offline`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["payment"],
    }),
    paymentClearance: builder.mutation<any, any>({
      query: (id) => ({
        url: `payment/clearance/${id}`,
        method: "PUT",
        body: {},
      }),
      invalidatesTags: ["payment", "dashboard", "paymentSummary"],
    }),
    getPaymentSummary: builder.query<any, void>({
      query: () => "payment/summary",
      providesTags: ["paymentSummary"],
    }),
    // PDF Download endpoint
    downloadPaymentConfirmationPdf: builder.mutation<Blob, string>({
      query: (paymentId) => ({
        url: `payment/${paymentId}/download-pdf`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    paymentVoucherDownload: builder.mutation<Blob, string>({
      query: (paymentId) => ({
        url: `pdf/generate-payment-voucher/${paymentId}`,
        method: "GET",
        responseHandler: (response) => response.blob(),
      }),
    }),
    allDueList: builder.query<any, void>({
      query: () => "payment/due",
      providesTags: ["payment"],
    }),
  }),
});

export const {
  useGetAllPaymentsQuery,
  useGetPaymentsPaginatedQuery,
  useGetPaymentByIdQuery,
  useProcessofflinePaymentMutation,
  useCreateAdditionalPaymentMutation,
  usePaymentClearanceMutation,
  useGetPaymentSummaryQuery,
  useDownloadPaymentConfirmationPdfMutation,
  useAllDueListQuery,
  useGetPaymentsByTransactionIdQuery,
  usePaymentVoucherDownloadMutation,
} = paymentApi;
